import join from 'url-join'

import { createAction, http, asyncAction } from '../../../util'
import config from '../../../config'

const api = join.bind(null, config.apiUrl)

export const EmulateUser = asyncAction({
    baseName: 'EMULATION_USER',
    action: action => (id, setADandJiraUser, clearIssues) => (dispatch) => {        
        dispatch(action.start())
        return http.get(api(`/ssp/user?id=${id}`))
        .then(userInfo => {
            dispatch(action.success())
            dispatch(setADandJiraUser(userInfo))
            dispatch(clearIssues())
        }).catch(err => {
            console.error('error getting api response', err)
            dispatch(action.error(err))
        })                
    }
})


// WEBPACK FOOTER //
// ./client/src/admin/tools/userEmulator/actions.js